<template>
  <modal
    :title="selectedLocationDetails ? 'Edit Address(es)' : 'Add Address(es)'"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div class="flex mt-1 gap-4 justify-end">
        <div >
          <label for="shipping" class="radio-label">
            <input
              class="bg-primary-yellow text-secondary-yellow"
              v-model="location.type"
              name="type"
              type="radio"
              id="shipping"
              value="takeoff"
            />

            Shipping
            <span></span>
          </label>
        </div>

        <div>
          <label for="consignee" class="radio-label">
            <input
              type="radio"
              v-model="location.type"
              value="delivery"
              id="consignee"
              name="type"
            />

            Destination
            <span></span>
          </label>
        </div>
      </div>
      <div>
        <label class="label">Country</label>
        <el-select
          filterable
          v-model="location.country"
          placeholder="Select country"
        >
          <el-option
            v-for="country in countries"
            :key="country"
            :label="country"
            :value="country"
          >
          </el-option>
        </el-select>
      </div>

      <div>
        <label class="label">State</label>
        <el-select
          filterable
          v-model="location.state"
          placeholder="Select state"
          @change="fetchCitiesInState"
        >
          <el-option
            v-for="state in states"
            :key="state.id"
            :label="state.name"
            :value="state.name"
          >
          </el-option>
        </el-select>
      </div>

      <div>
        <label class="label">City</label>
        <el-select filterable v-model="location.city" placeholder="Select city">
          <el-option
            v-for="city in cities"
            :key="city"
            :label="city"
            :value="city"
          >
          </el-option>
        </el-select>
      </div>

      <div>
        <label class="label">Address</label>
        <vue-google-autocomplete
          id="map2"
          :country="'ng'"
          ref="address"
          classname="input"
          :value="location.address ? location.address.name : ''"
          placeholder="Enter address"
          v-on:placechanged="setAddress"
        >
        </vue-google-autocomplete>
      </div>

      <div>
        <label class="label">Zip Code</label>
        <input
          type="text"
          class="input"
          placeholder="Enter zip code"
          v-model="location.zipCode"
        />
      </div>
    </div>
    <hr class="mt-2 mb-6" />
    <div class="flex justify-between">
      <p
        class="text-darkBlue cursor-pointer font-semibold bg-gray-300 items-center flex w-24 rounded-lg justify-center"
        @click="closeModal"
      >
        Back
      </p>
      <base-button
        :text="`${selectedLocationDetails ? 'Update' : 'Save'}`"
        :loading="loading"
        @click="submit"
      />
    </div>
  </modal>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: {
    VueGoogleAutocomplete,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    selectedLocationDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      location: {
        address: {
          name: "",
          lat: 6.123,
          lng: 3.456,
        },
        city: "",
        state: "",
        country: "",
        zipCode: "",
        userId:this.$store.state.authentication.userId,
        type: "takeoff",

        customerType: "private",
      },
      countries: ["Nigeria"],
      locationTypes: ["shipping", "destination"],

      states: [],
      cities: [],
    };
  },
  watch: {
    selectedLocationDetails() {
      this.location = {
        ...this.selectedLocationDetails,
        address: {
          ...this.selectedLocationDetails.address,
        },
      };
      this.locationType =
        this.selectedLocationDetails.type == "takeoff"
          ? "shipping"
          : "destination";
    },
  },
  mounted() {
    this.getAllStatesAndCities();
  },
  methods: {
    submit() {
      if (this.selectedLocationDetails) {
        this.updateLocation();
      } else {
        this.createLocation();
      }
    },
    async createLocation() {
      this.loading = true;
      try {
        if (this.location.type == "takeoff") {
          const response = await this.$_submitShipperInformation(this.location);
          this.log(response);
        } else {
          const response = await this.$_submitConsigneeInformation(
            this.location
          );
          this.log(response);
        }
        this.closeModal();
        this.generateToast("Location Created", "success");
        this.closeModal();
        this.$emit("completed");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async updateLocation() {
      this.loading = true;
      delete this.location.userId;
      delete this.location.updatedAt;
      delete this.location.createdAt;
      try {
        const response = await this.$_updateLocation(
          this.location.id,
          this.location
        );
        this.log(response);
        this.closeModal();
        this.$emit("completed");
        this.generateToast("Location Updated!", "success");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },

    closeModal() {
      this.location = {
        address: {
          name: "",
          lat: 6.123,
          lng: 3.456,
        },
        city: "",
        state: "",
        country: "",
        zipCode: "",
        customerType: "private",
      };
      this.$emit("close-modal");
    },

    fetchCitiesInState() {
      this.cities = this.states.filter(
        (item) => item.name == this.location.state
      )[0]?.cities;
    },
    async getCities(stateName) {
      this.cities = [];
      try {
        let response = await this.$_getCities(stateName);
        this.cities = response.data.allCities;
      } catch (error) {
        this.handleError(error);
      }
    },
    setAddress(addressData) {
      this.location.address.name = addressData.route;
      this.location.address.lat = addressData.latitude;
      this.location.address.lng = addressData.longitude;
    },
  },
};
</script>

<style scoped></style>
